const FIND_ACCOUNT_TAB_LIST = [
  { id: 1, text: '아이디 찾기' },
  { id: 2, text: '비밀번호 찾기' },
];

export default FIND_ACCOUNT_TAB_LIST;
